// import API from 'services/API';
import API from 'services/TAPS_API';
import { moment } from 'utils';

export default function getCertificateInfo(data) {
  return API.request({
    method: 'POST',
    url: '/certificate/info',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    mapper: function (data) {
      data.startDate = data.startDate ? moment.fromFullDatetime(data.startDate) : null;
      data.endDate = data.endDate ? moment.fromFullDatetime(data.endDate) : null;

      return data;
    },
  });
}
